import React from 'react';
import { useRouter } from 'next/router';

import Phone from '../Icons/Phone';
import Internet from '../Icons/Internet';
import TV from '../Icons/TV';
import Invoice from '../Icons/Invoice';
import LinePhone from '../Icons/LinePhone';
import HandShake from '../Icons/HandShake';
import Settings from '../Icons/Settings';
import Button from 'components/src/button';

const Categories: React.FC = () => {
  const router = useRouter();

  const categoryArray = [
    {
      id: 1,
      name: 'Farsími',
      icon: <Phone />,
      slug: 'farsimi',
    },
    {
      id: 2,
      name: 'Internet',
      icon: <Internet />,
      slug: 'internet',
    },
    {
      id: 3,
      name: 'Sjónvarp',
      icon: <TV />,
      slug: 'sjonvarp',
    },
    {
      id: 4,
      name: 'Reikningar',
      icon: <Invoice />,
      slug: 'reikningar',
    },
    {
      id: 5,
      name: 'Heimasími',
      icon: <LinePhone />,
      slug: 'heimasimi',
    },
    {
      id: 6,
      name: 'Stillingar',
      icon: <Settings />,
      slug: 'stillingar',
    },
    {
      id: 7,
      name: 'Fyrirtæki',
      icon: <HandShake />,
      slug: 'fyrirtaeki',
    },
  ];
  const handleRouteToSlug = (slug: string) => {
    // Navigate to the category's slug
    router.push(`/adstod/${slug}`);
  };
  return (
    <div>
      <div
        style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}
        className="flex-col gap-x-12 gap-y-24 md:flex-row"
      >
        {categoryArray.map((category) => (
          <Button
            key={category.id}
            label={category.name}
            icon={category.icon}
            iconPosition="left"
            variant="surface"
            classes="md:max-w-[30%]"
            labelClasses="text-red-100 !font-semibold"
            autoWidth={false}
            elevated
            onClick={() => handleRouteToSlug(category.slug)}
          />
        ))}
      </div>
    </div>
  );
};

export default Categories;
